import React from 'react';
import { Col, Layout, message, Row, Select ,Icon} from 'antd';
import moment from "moment";
import MiCompAPI from "../../util/api";
import ReportTableWrapper from "../elements/ReportTableWrapper";
import ExportJsonExcel from 'js-export-excel';
const { Content } = Layout;
const { Option } = Select;
class OutstandingReport extends React.Component {
    columns = [{
        title: 'Invoice No',
        dataIndex: 'inv_id',
        sorter: (a, b) => a.inv_id.localeCompare(b.inv_id),
        sortDirections: ["descend", "ascend"]
    }, {
        title: 'Invoice Date',
        dataIndex: 'date_of_gen',
        render: (text, record) => record["date_of_gen"] !== null && record["date_of_gen"] !== "" ? moment(record["date_of_gen"]).format("MM/DD/YYYY") : "",
        sorter: (a, b) => a.date_of_gen.localeCompare(b.date_of_gen),
        sortDirections: ["descend", "ascend"]
    },
    {
        title: 'Gross Amount',
        dataIndex: 'gross_Amount',
        align: 'right' ,
        render: (text, record) => "$" + record["gross_Amount"],
        sorter: (a, b) => a.gross_Amount-b.gross_Amount,
        sortDirections: ["descend", "ascend"]
    }, {
        title: 'Tax Amount',
        dataIndex: 'tax_amt',
        align: 'right' ,
        render: (text, record) => "$" + record["tax_amt"],
        sorter: (a, b) => a.tax_amt-b.tax_amt,
        sortDirections: ["descend", "ascend"]
    }, {
        title: 'Net Amount',
        dataIndex: 'net_amt',
        align: 'right' ,
        render: (text, record) => "$" + record["net_amt"],
        sorter: (a, b) => a.net_amt-b.net_amt,
        sortDirections: ["descend", "ascend"]
    }, {
        title: 'Outstanding Payment',
        dataIndex: 'outstanding_Payment',
        align: 'right' ,
        render: (text, record) => "$" + record["outstanding_Payment"],
        sorter: (a, b) => a.outstanding_Payment-b.outstanding_Payment,
        sortDirections: ["descend", "ascend"]
    }];
    constructor(props) {
        super(props);
        this.state = {
            agencies: null,
            oustanding: null,
            isLoading: false,
            brokers: null,
            months: null,
            years:null,
            year:new Date().getFullYear(),
            month: new Date().getMonth()+1,
            user_id: 0
        }
        this.tableButtons = [{
            buttonType: "primary",
            content: "Export Excel",
            clickHandler: () => {
                this.downloadExcel();
            }
        }];
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    downloadExcel = () => {
        const data = this.state.oustanding.user_OutStands ? this.state.oustanding.user_OutStands : '';//tabular data
        var option = {};
        let dataTable = [];
        if (data) {
            for (let i in data) {
                if (data) {
                    let obj = {
                        'Invoice No': data[i].inv_id,
                        'Invoice Date': data[i].date_of_gen,
                        'Gross Amount': "$" + data[i].gross_Amount,
                        'Tax Amount': "$" + data[i].tax_amt,
                        'Net Amount': "$" + data[i].net_amt,
                        'Outstanding Payment': "$" + data[i].outstanding_Payment,
                    }
                    dataTable.push(obj);
                }
            }
        }
        option.fileName = 'OutStanding'
        option.datas = [
            {
                sheetData: dataTable,
                sheetName: 'sheet',
                sheetFilter: ['Invoice No','Invoice Date',    'Gross Amount', 'Tax Amount', 'Net Amount', 'Outstanding Payment'],
                sheetHeader: ['Invoice No','Invoice Date',    'Gross Amount', 'Tax Amount', 'Net Amount', 'Outstanding Payment'],
            }
        ];
        if(dataTable.length>0){
            var toExcel = new ExportJsonExcel(option);
            toExcel.saveExcel();
        }
    }
    componentDidMount = () => {
        if (this.props.type !== "bsu") {
            this.getClientMasters();
        } else {
            this.getClientMasters();
            this.GetOutStandingPayment(0, this.state.month, this.state.year);
        }
    }
    onChange = (type, e) => {
        if (type === "user") {
            this.setState({
                user_id: e
            })
        }
        if (type === "month") {
            this.setState({
                month: e
            })
        }
        if (type === "year") {
            this.setState({
                year: e
            })
        }
        setTimeout(() => {
            if (this.state.user_id && this.state.month && this.state.year) {
                this.GetOutStandingPayment(this.state.user_id, this.state.month, this.state.year);
            }
            if(this.props.type==="bsu"&& this.state.month&&this.state.year){
                this.GetOutStandingPayment(0, this.state.month,this.state.year);
            }
        }, 100);
    }
    GetOutStandingPayment(id, month, year) {
        this.api.invoke(
            "GetOutStandingPayment/" + id + "/" + this.props.user_Type + "/" + month+"/"+year,
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.setState({
                            isLoading: false,
                            oustanding: data.data
                        })
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            });
    }
    getClientMasters() {
        this.api.invoke(
            "GetMasters",
            "post",
            (data, success) => {
                if (success) {
                    this.setState({
                        agencies: data.agencies,
                        brokers: data.brokers,
                        months: data.months,
                        years:data.years
                    });
                    if(this.props.type!=="bsu"){
                    if (this.props.user_Type === "B") {
                        this.setState({
                            user_id: data.brokers[0]?data.brokers[0].id :null                           })
                            if(data.brokers[0])
                        this.GetOutStandingPayment(data.brokers[0]?data.brokers[0].id :null  , this.state.month, this.state.year);
                    } else {
                        this.setState({
                            user_id: data.agencies[0]?data.agencies[0].id     :null                       })
                            if(data.agencies[0])
                        this.GetOutStandingPayment(data.agencies[0].id, this.state.month, this.state.year);
                    } }
                }else{
                    this.setState({
                        user_id: 0                           })
                    this.GetOutStandingPayment(0, this.state.month,this.state.year);
                }
            },
            ["AGENCY", "ADMINBROKER", "MTH","YR"]
        );
    }
    render() {
        const { decodedToken } = this.props.userPermandMasters;
        var role = decodedToken.UserRoleName;
        var { user_Address } = this.state.oustanding ? this.state.oustanding : '';
        const { title, user_Type } = this.props;
        return (
            <Content>
                <div className="mi_main_div">
                    <Row style={{ padding: '20px', background: 'white' }}>
                        <Col span={24}>
                            <p className="mi_table_title" style={{ textAlign: 'center', marginBottom: '60px' }}> {title}	</p>
                        </Col>
                        <Col span={24} style={{ marginBottom: '40px' }}>
                            <Row span={24}>
                                {role !== "broker"&&role !== "agency" ? user_Type === "A" ?
                                    this.state.agencies ?
                                        <Col span={8} style={{ padding: '0px 20px 0px 0px' }} >
                                            <h3><b>Agency : </b></h3>
                                            <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input_profile"
                                                onChange={this.onChange.bind(this, 'user')}
                                                placeholder="Please Select"
                                                showSearch={true}
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.props.children
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                }
                                                defaultValue={this.state.agencies[0]?this.state.agencies[0].id:undefined}
                                            >
                                                {this.state.agencies ? this.state.agencies.map((tag) => (
                                                    <Option value={tag.id} key={tag.id}>
                                                        {tag.name}
                                                    </Option>
                                                )) : ''}
                                            </Select>
                                        </Col> : '' : this.state.brokers ? <Col span={8} style={{ padding: '0px 20px 0px 0px' }}>
                                            <h3><b>Broker : </b></h3>
                                            <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input_profile"
                                                onChange={this.onChange.bind(this, 'user')}
                                                placeholder="Please Select"
                                                showSearch={true}
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.props.children
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                }
                                                defaultValue={this.state.brokers[0]?this.state.brokers[0].id:undefined}
                                            >
                                                {this.state.brokers ? this.state.brokers.map((tag) => (
                                                    <Option value={tag.id} key={tag.id}>
                                                        {tag.name}
                                                    </Option>
                                                )) : ''}
                                            </Select>
                                        </Col> : '' : ''}
                                <Col span={this.props.type==="bsu"?12:8} style={{ padding: '0px 20px' }}>
                                    <h3><b>Month : </b></h3>
                                    <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input_profile"
                                        onChange={this.onChange.bind(this, 'month')}
                                        placeholder="Please Select"
                                        showSearch={true}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        }
                                        defaultValue={this.state.month?this.state.month:undefined}
                                    >
                                        {this.state.months ? this.state.months.map((tag) => (
                                            <Option value={tag.id} key={tag.id}>
                                                {tag.name}
                                            </Option>
                                        )) : ''}
                                    </Select>
                                </Col>
                                <Col span={this.props.type==="bsu"?12:8} style={{ padding: '0px 20px' }}>
                                    <h3><b>Years : </b></h3>
                                    <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input_profile"
                                        onChange={this.onChange.bind(this, 'year')}
                                        placeholder="Please Select"
                                        showSearch={true}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        }
                                        defaultValue={this.state.year?this.state.year:undefined}
                                    >
                                        {this.state.years ? this.state.years.map((tag) => (
                                            <Option value={tag.id} key={tag.id}>
                                                {tag.name}
                                            </Option>
                                        )) : ''}
                                    </Select>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24} >
                            <Row style={{ width: '300px', float: 'right', marginTop: '50px' }}>
                                <Col span={24}><h4><b>Billing Address	 :</b> {user_Address ? user_Address.name + ", " + user_Address.street + ", " + user_Address.city + ', ' + user_Address.statename.split(' ')
                                    .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
                                    .join(' ') + ', ' + user_Address.zipcode.substring(0,5)+ "-" +user_Address.zipcode.substring(5,9) : 'None'}
                                    <br></br>
    Phone Number : {user_Address && user_Address.phone_Number.length === 10 ? <a href={"tel:+" + user_Address.phone_Number}>{"(" + user_Address.phone_Number.substring(0, 3) + ") " + user_Address.phone_Number.substring(3, 6) + "-" + user_Address.phone_Number.substring(6)}</a> : "Invalid US Number"}
                                    <br></br>
    Email : {user_Address && user_Address.email ? user_Address.email : 'None'} </h4></Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <ReportTableWrapper rowKey="plan_id" columns={this.columns} data={this.state.oustanding ? this.state.oustanding.user_OutStands : null} loading={this.state.isLoading} buttons={this.tableButtons} search={true} />
                        </Col>
                        <Col span={24}>
                        </Col>
                    </Row>
                </div>
            </Content>
        );
    }
}
export default OutstandingReport;